export const cut_shape_url: string = "cut_shape";
export const cut_shape_bulk_url: string = "bulk_cut_shape";
export const cut_shape_fitted_url: string = "cut_shape_fitted";
